export const version = "2.6.2";
export const iOSTemplateVersion = "v1.0.8";
export const macOSTemplateVersion = "v1.0.5";
export const packageName = "xcodebuildmcp";
export const repositoryOwner = "getsentry";
export const repositoryName = "XcodeBuildMCP";
